/**
 * Typisiertes Kapitel-Modell der Online-Dokumentation (/dokumentation).
 *
 * Inhalte sind bewusst reine Strings (keine JSX-Knoten), damit die
 * Volltextsuche über Titel + Text ohne Renderer funktioniert und die
 * Inhalte ohne React-Kontext testbar bleiben.
 */

export interface DocTabelle {
  kopf: string[]
  zeilen: string[][]
}

/** Querverweis auf einen anderen Doku-Abschnitt (Anker = "<kapitelId>-<abschnittId>") */
export interface DocVerweis {
  label: string
  anker: string
}

export interface DocAbschnitt {
  id: string
  titel: string
  /** Fließtext-Absätze */
  inhalt: string[]
  /** Nummerierte Schritt-für-Schritt-Anleitung */
  schritte?: string[]
  /** Hervorgehobene Hinweise (Info-Box) */
  hinweise?: string[]
  /** Tabelle (z. B. Rollen-Matrix, Rotationsbeispiel) */
  tabelle?: DocTabelle
  /** Wer darf die beschriebene Aktion ausführen (Rollen-Hinweis) */
  rollen?: string
  /** Deep-Link in die zugehörige App-Seite („Zur Seite“-Button) */
  seite?: { label: string; href: string }
  /** Querverweise auf andere Doku-Abschnitte */
  verweise?: DocVerweis[]
  /** Nur anzeigen, wenn die App im Dev-/Local-Modus läuft (z. B. Test-Hinweise) */
  nurDev?: boolean
}

export interface DocKapitel {
  id: string
  titel: string
  /** Kurzbeschreibung unter der Kapitel-Überschrift */
  kurz?: string
  abschnitte: DocAbschnitt[]
}

/** Anker-ID eines Abschnitts (auch von der Kontexthilfe im Header verwendet) */
export function ankerId(kapitelId: string, abschnittId: string): string {
  return `${kapitelId}-${abschnittId}`
}

/** Suchtext eines Abschnitts (Titel + alle String-Inhalte, lowercase) */
export function suchtext(a: DocAbschnitt): string {
  const teile: string[] = [
    a.titel,
    ...a.inhalt,
    ...(a.schritte ?? []),
    ...(a.hinweise ?? []),
    ...(a.tabelle ? [...a.tabelle.kopf, ...a.tabelle.zeilen.flat()] : []),
    a.rollen ?? "",
    a.seite?.label ?? "",
  ]
  return teile.join(" ").toLowerCase()
}
